/* eslint-disable warp-drive/no-legacy-request-patterns */

// loadRecordsInChunks breaks up a request for a large number of specific entities
// into chunks in order to avoid hitting the URL length limit by stuffing too
// many UUIDs into the query parameters in one go.
export function loadRecordsInChunks(
  store,
  entityType,
  idParam,
  ids,
  chunkSize = 50,
) {
  let promises = [];

  for (let i = 0; i < ids.length; i += chunkSize) {
    let slice = ids.slice(i, i + chunkSize);
    let chunk = store.query(entityType, { [idParam]: JSON.stringify(slice) });
    promises.push(chunk);
  }

  // Fetch all chunks, then return a merged list of the results.
  return Promise.all(promises).then((chunks) => {
    return chunks.reduce((merged, chunk) => {
      // Query results have no toArray() on WarpDrive 5.x.
      merged.push(...chunk.slice());
      return merged;
    }, []);
  });
}
